export const ValTextAndNumber = (
  prop,
  value,
  callback,
  mayusculas = true,
  maxlength = 0
) => {
  var sValue = "";
  var serror = false;
  var smensaje = "";
  if (value === undefined || value === null || value.length == 0) {
    sValue = "";
  }
  if (Number(maxlength) > 0 && value.length > Number(maxlength)) {
    serror = true;
    smensaje = ``;
    // smensaje = `Solo se permiten ${maxlength} caracteres`;
    sValue = value.substring(0, value.length - 1);
  } else {
    const pattern = new RegExp("^[ A-Z0-9]+$", "i");
    if (!pattern.test(value.slice(-1))) {
      sValue = value.substring(0, value.length - 1);
    } else {
      sValue = value;
    }
  }
  if (mayusculas === true) sValue = sValue.toUpperCase();
  return callback(prop, sValue, serror, smensaje);
};
